import axios from "axios";
export const lienImage = `${process.env.REACT_APP_LIEN_BACKEND_PROD}/public/public/image/`;
export const lienFacture = `${process.env.REACT_APP_LIEN_BACKEND_PROD}/public/public/contract/`;
export const lienPiece = `${process.env.REACT_APP_LIEN_BACKEND_PROD}/public/public/pièces/`;
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_LIEN_BACKEND_PROD}/api`,
});

instance.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
